import {lazy} from "react";

const FilterHome = lazy(() => import("./FilterHome"));

const filterRoutes = [
    {
        path: "/filter/:id",
        element: <FilterHome/>,
    },
];

export default filterRoutes;